define('DisplayCommerceCategoryFields.View', [
  'SCView',
  'unlockcommerce_displaycommercecategoryfields.tpl'
], function (
  SCViewComponent,
  Template
) {
  'use strict';

  var SCView = SCViewComponent.SCView;

  function DisplayCommerceCategoryFieldsView(options) {
    SCView.call(this);
    this.template = Template;
    this.content = options && options.catDesc || options.catFaq || '';
  }

  DisplayCommerceCategoryFieldsView.prototype = Object.create(SCView.prototype);

  DisplayCommerceCategoryFieldsView.prototype.constructor = DisplayCommerceCategoryFieldsView;

  DisplayCommerceCategoryFieldsView.prototype.getContext = function () {

    return {
      content: this.content
    };
  };

  return DisplayCommerceCategoryFieldsView;
}
);
